import { callApi } from '../../../api/call';

export const sendContactMessage = async (payload) => {
  const res = await callApi('/api/contact', payload, { auth: false });
  return res.data;
};
